import styled from 'styled-components'
import { formatSignificantParts } from 'utils/formatDollarAmt'

// Rendered as markup rather than Unicode subscripts, which many fonts lack and
// the fallback glyph sits low enough for the clipped text box to cut off.
const ZeroCount = styled.sub`
  font-size: 0.7em;
  line-height: 0;
  vertical-align: -0.15em;
`

/** A positive amount below 1 by its significant digits, collapsing long runs of zeros. */
export default function SmallAmount({ value, prefix = '' }: { value: number; prefix?: string }) {
  const parts = formatSignificantParts(value)
  if (typeof parts === 'string') return <>{`${prefix}${parts}`}</>
  return (
    // The visible text reads as 0.05406, so assistive tech gets the real value.
    <span aria-label={`${prefix}${value}`}>
      {`${prefix}0.0`}
      <ZeroCount>{parts.zeros}</ZeroCount>
      {parts.digits}
    </span>
  )
}
